import { skapi } from "@/main";

/**
 * Written to the user's misc.signup_origin when the account is created
 * through www.bunnyquery.com. www.skapi.com never writes this key, so an
 * account whose misc has no signup_origin is assumed to have joined via skapi.
 */
export const SIGNUP_ORIGIN = "bunnyquery";

/** misc payload for skapi.signup(): stamps the new account's origin at creation. */
export function signupMisc(): string {
    return JSON.stringify({ signup_origin: SIGNUP_ORIGIN });
}

/**
 * True when the profile's approval stamp ("{approver}:approved:{timestamp}")
 * is younger than maxAgeMs. False when the stamp is missing or unparseable.
 * Used to make sure a first-login origin tag only lands on a freshly created
 * account, never on an old account that just happens to visit this site.
 */
export function accountApprovedWithin(
    user: { approved?: string } | null | undefined,
    maxAgeMs: number,
): boolean {
    const stamp = typeof user?.approved === "string" ? user.approved.split(":").pop() : "";
    let ts = Number(stamp);
    if (!Number.isFinite(ts) || ts <= 0) return false;
    if (ts < 1e12) ts *= 1000; // seconds to milliseconds
    return Date.now() - ts < maxAgeMs;
}

let processing: Promise<void> | null = null;
export async function miscUpdater(toUpdate: any): Promise<void> {
    if (processing) await processing;

    const nextUpdate = { ...toUpdate };

    processing = (async () => {
        const getProfile = await skapi.getProfile();

        if (!getProfile) {
            // 프로필이 없는 경우 (로그인 안됨 등)
            throw new Error("User profile not available");
        }

        let currentMisc: Record<string, any> = {};
        if (getProfile.misc && typeof getProfile.misc === "string") {
            try {
                currentMisc = JSON.parse(getProfile.misc);
            } catch {
                currentMisc = {};
            }
        }

        for (let key in nextUpdate) {
            if (nextUpdate[key] === null) {
                delete currentMisc[key];
                continue;
            }

            currentMisc[key] = nextUpdate[key];
        }

        return skapi.updateProfile({
            misc: JSON.stringify(currentMisc),
        });
    })().finally(() => {
        processing = null;
    });

    return processing;
}